// extracted by mini-css-extract-plugin
export default {"button":"ButtonBlue_button__4gD+r"};